<template>
  <aside
    :class="['converter-welcome', `converter-welcome--${tone}`]"
    aria-label="Presentazione del convertitore"
  >
    <div
      :class="[
        'converter-welcome__format-flow',
        { 'converter-welcome__format-flow--pdf-only': isPdfOnly },
      ]"
      aria-hidden="true"
    >
      <div
        class="converter-welcome__format-group converter-welcome__format-group--input"
      >
        <img
          class="converter-welcome__format-icon converter-welcome__format-icon--pdf"
          src="/Pagina Convertitore/Icona PDF.png"
          alt=""
          decoding="async"
        />
        <img
          v-if="!isPdfOnly"
          class="converter-welcome__format-icon converter-welcome__format-icon--input-csv"
          src="/Pagina Convertitore/Icona CSV.png"
          alt=""
          decoding="async"
        />
      </div>

      <svg
        v-if="isPdfOnly"
        class="converter-welcome__flow-connector converter-welcome__flow-connector--single"
        viewBox="0 0 60 100"
        preserveAspectRatio="none"
      >
        <path d="M15 50 C28 50 39 50 51 50" />
        <path
          class="converter-welcome__flow-arrow"
          d="M53 50 L44 45 L44 55 Z"
        />
      </svg>
      <svg
        v-else
        class="converter-welcome__flow-connector converter-welcome__flow-connector--merge"
        viewBox="0 0 90 100"
        preserveAspectRatio="none"
      >
        <path d="M-18 30 C20 13 57 18 83 36" />
        <path d="M28 76 C49 82 70 74 83 64" />
        <path
          class="converter-welcome__flow-arrow"
          d="M84 36 L75.4 34.3 L79.4 28.5 Z"
        />
        <path
          class="converter-welcome__flow-arrow"
          d="M84 64 L79.8 71.7 L75.6 66.1 Z"
        />
      </svg>

      <div class="converter-welcome__exchange-icon">
        <img
          src="/Pagina Convertitore/Icona Scambio.png"
          alt=""
          decoding="async"
        />
      </div>

      <svg
        class="converter-welcome__flow-connector converter-welcome__flow-connector--split"
        viewBox="0 0 90 100"
        preserveAspectRatio="none"
      >
        <path d="M2 43 C28 43 50 10 82 24" />
        <path d="M2 57 C28 57 50 90 82 76" />
        <path
          class="converter-welcome__flow-arrow"
          d="M84 24 L75.3 24 L78.1 17.6 Z"
        />
        <path
          class="converter-welcome__flow-arrow"
          d="M84 76 L78.1 82.4 L75.3 76 Z"
        />
      </svg>

      <div
        class="converter-welcome__format-group converter-welcome__format-group--output"
      >
        <img
          class="converter-welcome__format-icon converter-welcome__format-icon--excel"
          src="/Pagina Convertitore/Icona Excel.png"
          alt=""
          decoding="async"
        />
        <img
          class="converter-welcome__format-icon converter-welcome__format-icon--output-csv"
          src="/Pagina Convertitore/Icona CSV.png"
          alt=""
          decoding="async"
        />
      </div>
    </div>

    <div class="converter-welcome__copy">
      <h2>{{ panelTitle }}<br />al tuo gestionale</h2>
      <p>{{ description }}</p>
    </div>

    <div class="converter-welcome__benefits" aria-label="Vantaggi">
      <div class="converter-welcome__benefit">
        <i class="fa-regular fa-file-lines"></i>
        <strong>{{ inputBenefitTitle }}</strong>
        <span>{{ inputFormatsLabel }}</span>
      </div>
      <div class="converter-welcome__benefit">
        <i class="fa-solid fa-arrows-rotate"></i>
        <strong>Interoperabilità</strong>
        <span>Compatibile con gestionali diversi</span>
      </div>
      <div class="converter-welcome__benefit">
        <i class="fa-solid fa-bolt"></i>
        <strong>Import veloce</strong>
        <span>Pronto per la conversione</span>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "ConverterWelcomePanel",
  props: {
    description: {
      type: String,
      required: true,
    },
    tone: {
      type: String,
      default: "prospetti",
      validator: (value) => ["prospetti", "f24", "bilancio"].includes(value),
    },
  },
  computed: {
    isPdfOnly() {
      return this.tone === "f24";
    },
    panelTitle() {
      return this.isPdfOnly ? "Da PDF" : "Da PDF e CSV";
    },
    inputFormatsLabel() {
      return this.isPdfOnly ? "PDF in ingresso" : "PDF e CSV in ingresso";
    },
    inputBenefitTitle() {
      return this.isPdfOnly ? "Input standard F24" : "Input flessibile";
    },
  },
};
</script>

<style>
.converter-welcome {
  --welcome-accent: #14795f;
  --welcome-rgb: 20, 121, 95;
  --welcome-heading: #123d3b;
  --welcome-flow-accent: #13846a;
  position: relative;
  isolation: isolate;
  display: flex;
  min-width: 0;
  min-height: clamp(31rem, calc(100dvh - 13.35rem), 50rem);
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: clamp(2rem, 4vw, 4.5rem);
  border: 1px solid rgba(var(--welcome-rgb), 0.14);
  border-radius: 20px;
  background: radial-gradient(
      circle at 86% 26%,
      rgba(var(--welcome-rgb), 0.12),
      transparent 34%
    ),
    linear-gradient(145deg, #ffffff 20%, #f7f9f8 100%);
  box-shadow: 0 18px 50px rgba(21, 64, 52, 0.08);
  color: #173f3c;
  text-align: center;
}

.converter-welcome--f24 {
  --welcome-accent: #336987;
  --welcome-rgb: 51, 105, 135;
  --welcome-heading: #274f66;
}

.converter-welcome--bilancio {
  --welcome-accent: #7b6a4b;
  --welcome-rgb: 123, 106, 75;
  --welcome-heading: #4a4033;
}

.converter-welcome::after {
  position: absolute;
  z-index: -1;
  right: -11%;
  bottom: -24%;
  width: 70%;
  height: 62%;
  border-radius: 50% 0 0 0;
  background: linear-gradient(
    135deg,
    rgba(var(--welcome-rgb), 0.04),
    rgba(var(--welcome-rgb), 0.14)
  );
  content: "";
  transform: rotate(-12deg);
}

.converter-welcome__format-flow {
  position: relative;
  display: grid;
  width: min(100%, 32.6rem);
  height: 7.5rem;
  grid-template-columns: 7.6rem 6rem 5.4rem 4.2rem 9.4rem;
  align-items: center;
  justify-content: center;
  margin-bottom: clamp(1rem, 2vh, 1.35rem);
}

.converter-welcome__format-flow--pdf-only {
  width: min(100%, 32.6rem);
  grid-template-columns: 7.6rem 6rem 5.4rem 4.2rem 9.4rem;
}

@media (min-height: 900px) {
  .converter-welcome__format-flow {
    margin-bottom: clamp(1.25rem, 2.4vh, 1.65rem);
  }
}

.converter-welcome__flow-connector {
  z-index: 2;
  display: block;
  width: 100%;
  height: 72%;
  overflow: visible;
  color: var(--welcome-flow-accent);
}

.converter-welcome__flow-connector > path:not(.converter-welcome__flow-arrow) {
  fill: none;
  stroke: currentColor;
  stroke-dasharray: 4 6.5;
  stroke-linecap: round;
  stroke-width: 1.65;
  vector-effect: non-scaling-stroke;
  opacity: 0.82;
}

.converter-welcome__flow-arrow {
  fill: currentColor;
  stroke: none;
  opacity: 0.84;
}

.converter-welcome__flow-connector--single {
  height: 3.75rem;
  min-height: 0;
  align-self: center;
}

.converter-welcome__flow-connector--merge {
  height: 100%;
}

.converter-welcome__format-group,
.converter-welcome__exchange-icon {
  position: relative;
  z-index: 1;
  min-width: 0;
  height: 100%;
}

.converter-welcome__format-icon,
.converter-welcome__exchange-icon img {
  position: absolute;
  display: block;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 9px 11px rgba(31, 63, 54, 0.11));
}

.converter-welcome__format-icon {
  height: 82%;
}

.converter-welcome__format-icon--pdf {
  top: 0;
  left: 0;
}

.converter-welcome__format-icon--input-csv {
  right: -1.5rem;
  bottom: 0;
  height: 70%;
}

.converter-welcome__format-flow--pdf-only .converter-welcome__format-icon--pdf {
  top: 50%;
  right: -1.5rem;
  left: auto;
  height: 7.6rem;
  transform: translateY(-50%);
}

.converter-welcome__exchange-icon img {
  top: 50%;
  left: 50%;
  width: min(100%, 5.4rem);
  max-height: 92%;
  filter: drop-shadow(0 10px 14px rgba(20, 121, 95, 0.14));
  transform: translate(-50%, -50%);
}

.converter-welcome__format-icon--excel {
  top: 0;
  left: 0;
  height: 90%;
}

.converter-welcome__format-icon--output-csv {
  right: 0;
  bottom: 0;
  height: 68%;
}

.converter-welcome__copy h2 {
  margin: 0;
  color: var(--welcome-heading);
  font-size: clamp(2rem, 3.2vw, 3.35rem);
  font-weight: 800;
  letter-spacing: -0.035em;
  line-height: 1.05;
}

.converter-welcome__copy p {
  max-width: 44rem;
  margin: 1rem auto 0;
  color: #4d6570;
  font-size: clamp(1rem, 1.25vw, 1.3rem);
  line-height: 1.5;
  white-space: pre-line;
}

.converter-welcome__benefits {
  display: grid;
  width: min(100%, 50rem);
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(1rem, 2vw, 2rem);
  margin-top: clamp(2.2rem, 5vh, 4.25rem);
  transform: translateY(clamp(1.6rem, 4.5vh, 2.5rem));
}

.converter-welcome__benefit {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
}

.converter-welcome__benefit i {
  margin-bottom: 0.35rem;
  color: var(--welcome-accent);
  font-size: 1.65rem;
}

.converter-welcome__benefit strong {
  color: var(--welcome-heading);
  font-size: 1.05rem;
}

.converter-welcome__benefit span {
  color: #657782;
  font-size: 0.88rem;
  line-height: 1.3;
}

.dm .converter-welcome {
  border-color: rgba(112, 180, 156, 0.18);
  background: radial-gradient(
      circle at 86% 26%,
      rgba(var(--welcome-rgb), 0.13),
      transparent 34%
    ),
    linear-gradient(145deg, #222a2b 20%, #1c2926 100%);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
}

.dm .converter-welcome__copy h2,
.dm .converter-welcome__benefit strong {
  color: #edf8f4;
}

.dm .converter-welcome__copy p,
.dm .converter-welcome__benefit span {
  color: #b8c8c4;
}

@media (max-width: 700px) {
  .converter-welcome {
    min-height: 30rem;
    padding: 2rem 1.25rem;
  }

  .converter-welcome__benefits {
    gap: 0.6rem;
    transform: none;
  }

  .converter-welcome__format-flow {
    width: 100%;
    height: 6.7rem;
    grid-template-columns: minmax(5.2rem, 1fr) 2.7rem 4.4rem 2.7rem minmax(
        5.5rem,
        1fr
      );
  }

  .converter-welcome__format-flow--pdf-only {
    grid-template-columns: minmax(5.2rem, 1fr) 2.7rem 4.4rem 2.7rem minmax(
        5.5rem,
        1fr
      );
  }

  .converter-welcome__format-flow--pdf-only
    .converter-welcome__format-icon--pdf {
    right: -0.5rem;
  }

  .converter-welcome__benefit span {
    font-size: 0.76rem;
  }
}
</style>
